import callAPI from "../callApi";
import path from "../variables";

const HumanResource = {
	leave: {
		getAll: () => callAPI("GET", `${path.base}/humanresource/leaves`, "", "getting all leaves"),
		create: (data: any) => callAPI("POST", `${path.base}/humanresource/leaves`, data, "creating new leave"),
		approve: (id: number, data: any = {}) => callAPI("POST", `${path.base}/humanresource/leaves/approve/${id}`, data, "approving leave"),
		reject: (id: number, data: any = {}) => callAPI("POST", `${path.base}/humanresource/leaves/reject/${id}`, data, "rejecting leave"),
		remove: (id: number) => callAPI("DELETE", `${path.base}/humanresource/leaves/${id}`, "", "deleting leave"),
	},
	bonus: {
		getAll: () => callAPI("GET", `${path.base}/humanresource/bonuses`, "", "getting all bonuses"),
		create: (data: any) => callAPI("POST", `${path.base}/humanresource/bonuses`, data, "creating new bonus"),
	},
	region: {
		getAll: () => callAPI("GET", `${path.base}/others/regions`, "", "getting all regions"),
		create: (data: any) => callAPI("POST", `${path.base}/others/regions`, data, "creating new region"),
	},
	// HR Dashboard — payroll, payslip, leave balances, absence calendar
	payslip: (personalId: number, year: number, month: number) =>
		callAPI("GET", `${path.base}/business/hr/payslip?personal_id=${personalId}&year=${year}&month=${month}`, "", "generating payslip"),
	payroll: (year: number, month: number) =>
		callAPI("GET", `${path.base}/business/hr/payroll?year=${year}&month=${month}`, "", "generating payroll"),
	leaveBalance: (personalId: number, year?: number) =>
		callAPI("GET", `${path.base}/business/hr/leave-balance?personal_id=${personalId}${year ? '&year=' + year : ''}`, "", "getting leave balance"),
	allLeaveBalances: (year?: number) =>
		callAPI("GET", `${path.base}/business/hr/all-leave-balances${year ? '?year=' + year : ''}`, "", "getting all leave balances"),
	leaveEligible: (threshold?: number) =>
		callAPI("GET", `${path.base}/business/hr/leave-eligible${threshold != null ? '?threshold=' + threshold : ''}`, "", "getting employees eligible for leave"),
	absenceCalendar: (year: number, month: number) =>
		callAPI("GET", `${path.base}/business/hr/absence-calendar?year=${year}&month=${month}`, "", "getting absence calendar"),
	markPayslipPaid: (id: number, data: { method?: string; reference?: string } = {}) =>
		callAPI("POST", `${path.base}/business/hr/payslips/${id}/mark-paid`, data, "marking payslip as paid"),
	unpayPayslip: (id: number) =>
		callAPI("POST", `${path.base}/business/hr/payslips/${id}/unpay`, {}, "reverting payslip to draft"),
};

export default HumanResource;
